import { useRegisterSW } from 'virtual:pwa-register/react'

/**
 * Quiet bottom toast shown when a new deploy's service worker is waiting.
 * Activation only on explicit user action (guards against update loops).
 */
export function UpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  if (!needRefresh) return null

  return (
    <div
      role="status"
      className="fixed bottom-20 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 items-center justify-between gap-3 rounded-xl border border-[color:var(--hairline)] bg-bg-card px-4 py-3 shadow-xl"
    >
      <span className="text-sm text-text-primary">A new version is ready.</span>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          className="text-sm text-text-muted"
          onClick={() => setNeedRefresh(false)}
        >
          Later
        </button>
        <button
          type="button"
          className="text-sm font-medium text-accent-fg"
          onClick={() => void updateServiceWorker(true)}
        >
          Refresh
        </button>
      </div>
    </div>
  )
}
